import styled from "styled-components"
import { Popovers } from "../../element-components"
import React from "react"
import MuiCheckbox from "@mui/material/Checkbox";
import { Flex } from "../../container-components"
import { Typography } from "../../typo-components"
// // import React, { useState } from "react";
// // import styled from "styled-components";
// // import { Styles, Types } from "../../config";

// // import { Flex } from "../../container-components";
// // import { Icon, Typography } from "../../typo-components";

// // const CheckboxContainer = styled.div`
// //   height: 25px;
// //   width: 25px;
// //   position: relative;
// //   z-index: 1;
// //   cursor: pointer;
// // `;

// // const CheckboxVessel = styled.input`
// //   position: absolute;
// //   height: 25px;
// //   width: 25px;
// //   -webkit-appearance: none;
// //   -moz-appearance: none;
// //   -o-appearance: none;
// //   appearance: none;
// //   border: 1px solid
// //     ${(props) =>
// //       props.color ? Styles.Color[props.color] : Styles.Color.primary};
// //   border-radius: 4px;
// //   outline: none;
// //   transition-duration: 0.3s;

// //   cursor: pointer;
// //   background-color: transparent;

// //   &:checked {
// //     background-color: ${(props) =>
// //       props.color ? Styles.Color[props.color] : Styles.Color.primary};
// //   }

// //   &:active {
// //     border: 2px solid
// //       ${(props) =>
// //         props.color ? Styles.Color[props.color] : Styles.Color.primary};
// //   }
// // `;

// // interface Props {
// //   label?;
// //   checked?: boolean;
// //   defaultChecked?: boolean;
// //   onChange;
// //   style?: React.CSSProperties;
// //   margin?: string;
// //   yAlign?: string;
// //   disabled?: boolean;
// //   helperText?;
// //   innerMargin?: string;
// //   color?: string;
// // }


// //   return (
// //     <Flex
// //       style={{ margin: margin || "10px 0 10px", ...style }}
// //       column
// //       yAlign="flex-start"
// //     >
// //       <Flex nowrap yAlign={yAlign || "flex-start"}>
// //         <CheckboxContainer onClick={onChange}>
// //           <CheckboxVessel
// //             id={checkboxName}
// //             type="checkbox"
// //             defaultChecked={defaultChecked}
// //             color={color}
// //             checked={checked}
// //             disabled={disabled}
// //             style={{
// //               padding: "0",
// //               margin: "0",
// //             }}
// //           />
// //           {checked && (
// //             <Icon
// //               name="done"
// //               size="very-small"
// //               color="white"
// //               style={{ position: "absolute", top: "8px", left: "9px" }}
// //             ></Icon>
// //           )}
// //         </CheckboxContainer>

// //         <Typography
// //           margin="0 0 10px"
// //           variant="t6"
// //           style={{ color: "rgba(0, 0, 0, 0.54)" }}
// //         >
// //           {label}
// //         </Typography>
// //       </Flex>
// //       {helperText && (
// //         <Typography variant="t7" className="color-primary">
// //           {helperText}
// //         </Typography>
// //       )}
// //     </Flex>
// //   );
// // };

// // export default Checkbox;

const Wrapper = styled.div``

// & > * {
//   color: ${(props) => Styles.Color[props.color] || "white"}!important;
//   fill: ${(props) => {
//     const fill = props.disabled
//       ? Styles.Color.disabled
//       : Styles.Color[props.fill] || "primary";

//     return fill;
//   }}!important;
// }
// & > path {
//   background: ${(props) =>
//     Styles.Color[props.background] || "white"}!important;
// }





const Checkbox= ({
	label,
	checked,
	margin,
	style,
	yAlign,
	helperText,
	onChange,
	disabled,
	defaultChecked,
	innerMargin,
	color,
	fill,
	background,
	popover
}) => {
	if (typeof popover === "function") popover = popover()

	return (
		<Flex style={{ margin: margin || "10px 0 10px", ...style }} column yAlign="flex-start">
			<Flex nowrap yAlign={yAlign || "flex-start"} xAlign="flex-start">
				<Wrapper
					color={color || "primary"}
					fill={fill || "white"}
					background={background || "white"}
					disabled={disabled}
				>
					<MuiCheckbox
						defaultChecked={defaultChecked}
						onChange={onChange}
						color="primary"
						checked={checked}
						disabled={disabled}
						style={{
							padding: "0",
							margin: innerMargin || "0 10px 10px 0"
						}}
					/>
				</Wrapper>
				<Typography
					margin="0 0 10px"
					variant="t6"
					style={{ color: style?.typography?.color ? style?.typography?.color : "rgba(0, 0, 0, 0.54)" }}
					{...style?.typography}
				>
					{label}
					{Boolean(popover) && (
						<Popovers.Icon
							margin={"0px 0px 10px 3px"}
							iconConfig={{ name: "info", size: "very-small" }}
							popoverConfig={popover}
						/>
					)}
				</Typography>
			</Flex>
			{helperText && (
				<Typography variant="t7" className="color-primary">
					{helperText}
				</Typography>
			)}
		</Flex>
	)
}

export default Checkbox
